import SliderManager from '../../js/components/sliderManager';
import CustomSlider from '../../custom-slider/src/customSlider';
import DeviceDetector from '../../js/components/deviceDetector';
import ScrollManager from '../../js/components/scrollManager';

export default class ImageGalleryList extends HTMLElement {
    constructor() {
        super();
        this.customSlider = new CustomSlider();
        this.deviceDetector = new DeviceDetector();
        this.scrollManager = new ScrollManager();
        this.imageGalleryListContainerSelector = 'image-gallery-list-container';
        this.imageGallerySliderSectionSelector = 'image-gallery-slider-section';
        this.initialized = false;
    }

    connectedCallback() {
        this.stylesheet = this.getAttribute('stylesheet');
        this.imageUrls = JSON.parse(this.getAttribute('image-urls')) || [];
        if (this.imageUrls.length === 0 || this.stylesheet === null || this.shadowRoot) {
            return;
        }

        this._shadowRoot = this.attachShadow({ mode: 'open' });
        const t = document.querySelector('#image-gallery-list');
        if (!t) {
            return;
        }
        this.instance = t.content.cloneNode(true);
        this.instance.querySelector('[name="stylesheet"]').href = this.stylesheet;
        this.dataTitleChange = this.getAttribute('data-title-change');


        this._shadowRoot.appendChild(this.instance);
    }

    static get observedAttributes() {
        return ['imageUrls', 'stylesheet'];
    }

    initializeSwiper(swiper) {
        this.sliderManager = new SliderManager(swiper);
        this._buildImageGalleryListContainer();
        this._buildImageGallerySliderContainer();
        this.initialized = true;
        let event = new Event('image-gallery-list-initialized');
        this.dispatchEvent(event);

    }

    _buildImageGallerySliderContainer() {
        let customSliderElement = this.customSlider.buildSlider(this._buildImages(true));
        if (this._shadowRoot) {
            this.imageGallerySliderContainer = this._shadowRoot.querySelector('[name="image-gallery-slider-container"]');

            this.imageGallerySliderContainer.appendChild(customSliderElement);

            this.sliderElement = this.sliderManager.addSlider(this.imageGallerySliderContainer, {
                slidesPerView: 1,
                navigation: true,
                pagination: true,
                thumbs: null,
                centerSlides: true,
                autoHeight: true,
            });

            if (this.dataTitleChange) {
                this.sliderElement.on('slideChange', (event) => {
                    const listId = event.slides[event.activeIndex]
                        .querySelector('[data-title-selector]')
                        .getAttribute('data-title-selector');
                    if (listId) {
                        this._updateGroupLabel(listId);
                    }
                });
            }
        }
    }

    _buildImageGalleryListContainer() {
        let imageGalleryListContainer
        if (this.instance) {
            imageGalleryListContainer = this.instance.querySelector(
            `[name="${this.imageGalleryListContainerSelector}"]`,
        );
        }
        if (!imageGalleryListContainer && this._shadowRoot) {
            imageGalleryListContainer = this._shadowRoot.querySelector(
                `[name="${this.imageGalleryListContainerSelector}"]`,
            );
            imageGalleryListContainer.textContent = '';
        }
        let position = 0;
        let image;
        for (const images of this.imageUrls) {
            let groupLabel = null;
            if (images.label) {
                groupLabel = this._createGroupLabel(images.label);
            }

            if (!images.img) {
                continue;
            }
            for (let [i, url] of images.img.entries()) {
                i = position;
                image = this._buildImage(url, i, false, images.id);
                image.addEventListener('click', (event) => {
                    this._onShowImageGallerySlider(i, images.id);
                });
                if (groupLabel) {
                    const imgContainer = document.createElement('div');
                    imgContainer.classList.add('image-container');
                    imgContainer.append(image);
                    imgContainer.append(groupLabel.cloneNode(true));
                    image = imgContainer;
                }
                imageGalleryListContainer.appendChild(image);
                position++;
            }
        }
    }

    _buildImages(slider = false) {
        let imageList = [];
        let image;

        for (const images of this.imageUrls) {
            if (!images.img) {
                continue;
            }
            for (const [i, url] of images.img.entries()) {
                image = this._buildImage(url, i, slider, images.id);
                imageList.push(image);
            }
        }
        return imageList;
    }

    _buildImage(url, i, slider, titleSelector, imageId) {
        let image = document.createElement('img');

        if (slider) {
            image.setAttribute('data-src', url);
        } else {
            image.setAttribute('data-entity', 'slider-item');
            image.setAttribute('data-src', url);
        }

        image.setAttribute('loading', 'lazy');
        image.setAttribute('src', url);

        image.setAttribute('number', i);
        image.setAttribute('image-id', imageId);

        if (titleSelector) {
            image.setAttribute('data-title-selector', titleSelector);
        }
        return image;
    }

    onClickBack(showGalleryList) {
        const imageGalleryListContainerSelector = this._shadowRoot.querySelector(
            `[name="${this.imageGalleryListContainerSelector}"]`,
        );

        if (imageGalleryListContainerSelector.classList.contains('hide')) {
            const slider = this._shadowRoot.querySelector(
                `[name="${this.imageGallerySliderSectionSelector}"] .swiper-slide-active`,
            );
            let sliderId = null;
            if (slider) {
                sliderId = slider.getAttribute('num');
            }
            this._onShowImageGalleryList(sliderId, showGalleryList);
            return showGalleryList;
        }
        return false;
    }

    _onShowImageGallerySlider(sliderId, listId) {
        const imageGallerySliderSection = this._shadowRoot.querySelector(
            `[name="${this.imageGallerySliderSectionSelector}"]`,
        );
        const imageGalleryListContainerSelector = this._shadowRoot.querySelector(
            `[name="${this.imageGalleryListContainerSelector}"]`,
        );

        this._showSidebar();
        this._addGalleryModalDarkMode(imageGallerySliderSection);

        imageGallerySliderSection.classList.remove('hide');
        imageGalleryListContainerSelector.classList.add('hide');

        if (listId) {
            this._updateGroupLabel(listId);
        }

        this.sliderElement.slideTo(sliderId, 0, () => {
            this.sliderElement.update();
        });
    }

    _onShowImageGalleryList(sliderId, showGallery = true) {
        const imageGallerySliderSection = this._shadowRoot.querySelector(
            `[name="${this.imageGallerySliderSectionSelector}"]`,
        );
        const imageGalleryListContainerSelector = this._shadowRoot.querySelector(
            `[name="${this.imageGalleryListContainerSelector}"]`,
        );
        if (!imageGallerySliderSection || !imageGalleryListContainerSelector) return;

        this._hideSidebar();
        this._addGalleryModalDarkMode(imageGallerySliderSection);

        imageGallerySliderSection.classList.add('hide');
        if (!showGallery) {
            return;
        }
        imageGalleryListContainerSelector.classList.remove('hide');

        if (this.deviceDetector.isCurrentBreakpointLowerThan('lg')) {
            this._scrollToImage(imageGalleryListContainerSelector, sliderId);
        }

        this._updateGroupLabel('list');
    }

    onShow(sliderId = null) {
        if (sliderId !== null) {
            this._onShowImageGallerySlider(sliderId);
        } else {
            this._onShowImageGalleryList();
        }
    }

    updateImages(galleryImages) {
        this.imageUrls = galleryImages;

        this._buildImageGalleryListContainer();
        this._onShowImageGalleryList();
        this.imageGalleryThumbSliderContainer.lastElementChild.remove();
        this.imageGallerySliderContainer.lastElementChild.remove();
        this._buildImageGallerySliderContainer();
    }

    _createGroupLabel(name) {
        const labelContainer = document.createElement('div');
        labelContainer.classList.add('img-label-container');
        const label = document.createElement('span');
        label.classList.add('img-label');
        label.innerHTML = name;
        labelContainer.append(label);
        return labelContainer;
    }

    _updateGroupLabel(listId) {
        if (!this.dataTitleChange) {
            return;
        }
        document.querySelectorAll(this.dataTitleChange).forEach((element) => {
            element.dispatchEvent(
                new CustomEvent('change-title', {
                    detail: {
                        id: listId,
                    },
                }),
            );
        });
    }

    _scrollToImage(container, sliderId) {
        if (!sliderId || sliderId < 1) {
            return;
        }

        try {
            const elementToScroll = container.querySelector('img[number="' + sliderId + '"]');
            const currentOffset = elementToScroll.offsetParent.offsetTop - 10;
            const defaultOffset = container.querySelector('img').offsetParent.offsetTop;
            const containerScroll = this.closest('gallery-modal').shadowRoot.querySelector(
                '[data-container="modal-body"]',
            );
            this.scrollManager.scrollTo(
                '',
                null,
                null,
                elementToScroll,
                containerScroll,
                currentOffset > defaultOffset ? defaultOffset + 10 : defaultOffset,
            );
        } catch (e) {}
    }

    _addGalleryModalDarkMode(imageGallerySliderSection = null) {
        let galleryModal = this.closest('.modal .modal-content');
        if (!galleryModal) {
            galleryModal = this.closest('gallery-modal');
            if (galleryModal) {
                const hotelRatingSummary = galleryModal.querySelector('hotel-rating-summary');
                const hotelRating = galleryModal.querySelectorAll('rating-summary');
                if (hotelRatingSummary) {
                    const hotelRatingSummaryContainer = hotelRatingSummary.shadowRoot.querySelector(
                        '.hotel-rating-summary-container',
                    );
                    if (hotelRatingSummaryContainer) {
                        hotelRatingSummaryContainer.classList.add('modal-content-dark');
                    }
                }

                if (hotelRating) {
                    hotelRating.forEach((rating) => {
                        const hotelRatingContainer = rating.shadowRoot.querySelector('.rating-category');
                        if (hotelRatingContainer) {
                            hotelRatingContainer.classList.add('modal-content-dark');
                        }
                    });
                }
                galleryModal = galleryModal.shadowRoot.querySelector('.modal-content');
            } else {
                galleryModal = null;
            }
        }

        if (galleryModal) {
            const userReview = galleryModal.querySelector('user-review');
            if (userReview) {
                const userReviewSimple = userReview.shadowRoot.querySelector('[name="user-review"]');
                if (userReviewSimple) {
                    userReviewSimple.classList.add('modal-content-dark', 'user-review-simple');
                }
            }
            galleryModal.classList.add('modal-content-dark');
            if (imageGallerySliderSection) {
                imageGallerySliderSection.classList.add('modal-content-dark');
            }
        }
    }

    _hideSidebar() {
        const galleryModal = this.closest('.modal .modal-content');
        if (galleryModal) {
            const modalBodyContainer = galleryModal.querySelector('[name="modal-body-content-container"]');
            if (this.getAttribute('data-entity') == 'gallery-hotel-survey' && modalBodyContainer) {
                modalBodyContainer.classList.add('body-content-full');
            }
        }
    }

    _showSidebar() {
        const galleryModal = this.closest('.modal .modal-content');
        if (galleryModal) {
            const modalBodyContainer = galleryModal.querySelector('[name="modal-body-content-container"]');
            if (this.getAttribute('data-entity') == 'gallery-hotel-survey' && modalBodyContainer) {
                modalBodyContainer.classList.remove('body-content-full');
            }
        }
    }
}
